import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-label-value',
  templateUrl: './label-value.component.html',
  styleUrls: ['./label-value.component.scss']
})
export class LabelValueComponent implements OnInit {
  @Input() labelKey: string;
  @Input() value: string;

  constructor() {}

  ngOnInit() {}
}
